const linesFields = [
  {
    key: 'Id',
    field: 'id',
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'StatusName',
    field: 'statusName',
    title: ' Status Name',
    label: 'StatusName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SODate',
    field: 'soDate',
    title: ' SODate',
    label: 'SODate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseOrderId',
    field: 'purchaseOrderId',
    title: ' Purchase Order Id',
    label: 'PurchaseOrderId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PODate',
    field: 'poDate',
    title: ' PODate',
    label: 'PODate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DueDate',
    field: 'dueDate',
    title: ' Due Date',
    label: 'DueDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: 'companyName',
    title: 'Vendor',
    label: 'Vendor',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ContactFullName',
    field: 'contactFullName',
    title: ' Contact',
    label: 'ContactFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
]

export default linesFields;
